// @mui
import { Button, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
// sections
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import { OrderNewEditForm } from 'src/sections/@dashboard/order/OrderNewEditForm';
import { IUser } from '../../../@types/user';
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs';
import { useSettingsContext } from '../../../components/settings';
import { useLocales } from '../../../locales';
// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../../../routes/paths';
import { PERMISSIONS, hasPermission } from '../../../utils/permissions';

// ----------------------------------------------------------------------

export default function OrderCreatePage() {
  const { translate } = useLocales();
  const { themeStretch } = useSettingsContext();

  const { user } = useAuthContext();
  const navigate = useNavigate();

  if (!hasPermission(user as IUser, PERMISSIONS.orderCreate)) {
    navigate(PATH_PAGE.page403);
  }

  return (
    <>
      <Button
        color="inherit"
        startIcon={<Iconify width={16} icon={'eva:arrow-ios-back-fill'} />}
        sx={{
          height: 40,
          flexShrink: 0,
          borderRadius: 0,
          typography: 'overline',
          color: 'text.disabled',
          justifyContent: 'space-between',
          p: (theme) => theme.spacing(1, 1.5, 1, 2.5),
        }}
        onClick={() => navigate(-1)}
      >
        {`${translate('backward')}`}
      </Button>
      <Helmet>
        <title> {`${translate('orderCreatePage.title')}`} </title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading={`${translate('orderCreatePage.headingCreate')}`}
          links={[
            {
              name: `${translate('dashboardName')}`,
              href: PATH_DASHBOARD.root,
            },
            {
              name: `${translate('order')}s`,
              href: PATH_DASHBOARD.orders.ordersList,
            },
            { name: `${translate('orderCreatePage.newOrder')}` },
          ]}
        />
        <OrderNewEditForm />
      </Container>
    </>
  );
}
